import { useEffect, useState } from 'react';

import { Modal } from '../../components/Modal';
import { CloseIcon } from '../../icons/CloseIcon';
import { DEFAULT_LABELS, SignInForm } from './SignInForm';
import { CloseButton, Panel } from './SignInModal.styles';
import type { SignInFormMode, SignInModalProps } from './SignInModal.types';

export function SignInModal({
  open,
  onClose,
  labels,
  mode: controlledMode,
  onModeChange,
  ...formProps
}: SignInModalProps) {
  const merged = { ...DEFAULT_LABELS, ...labels };
  const [internalMode, setInternalMode] = useState<SignInFormMode>('signIn');
  const mode = controlledMode ?? internalMode;

  useEffect(() => {
    if (!open && controlledMode === undefined) setInternalMode('signIn');
  }, [open, controlledMode]);

  const handleModeChange = (next: SignInFormMode) => {
    onModeChange?.(next);
    if (controlledMode === undefined) setInternalMode(next);
  };

  const isSignUp =
    mode === 'signUp' &&
    Boolean(formProps.signUpValues && formProps.onSignUpChange && formProps.onSignUpSubmit);
  const ariaLabel = isSignUp ? merged.signUpTitle : merged.title;

  return (
    <Modal open={open} onClose={onClose} ariaLabel={ariaLabel}>
      <Panel data-testid="sign-in-modal">
        <CloseButton type="button" onClick={onClose} aria-label={merged.close}>
          <CloseIcon />
        </CloseButton>

        <SignInForm mode={mode} onModeChange={handleModeChange} labels={labels} {...formProps} />
      </Panel>
    </Modal>
  );
}
